/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PageIsPristineQueryVariables = GraphQL.Exact<{
  legacyUrlId: GraphQL.Scalars['Int']['input'];
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type PageIsPristineQuery = { readonly __typename?: 'Query', readonly lookupPageByLegacyId: { readonly __typename?: 'Page', readonly id: CK.UrlId, readonly isPristine: boolean } | null };


export const PageIsPristineDocument = gql`
    query PageIsPristine($legacyUrlId: Int!, $websiteId: WebsiteId!) {
  lookupPageByLegacyId(legacyUrlId: $legacyUrlId, websiteId: $websiteId) {
    id
    isPristine
  }
}
    `;

/**
 * __usePageIsPristineQuery__
 *
 * To run a query within a React component, call `usePageIsPristineQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageIsPristineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageIsPristineQuery({
 *   variables: {
 *      legacyUrlId: // value for 'legacyUrlId'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function usePageIsPristineQuery(baseOptions: Apollo.QueryHookOptions<PageIsPristineQuery, PageIsPristineQueryVariables> & ({ variables: PageIsPristineQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageIsPristineQuery, PageIsPristineQueryVariables>(PageIsPristineDocument, options);
      }
export function usePageIsPristineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageIsPristineQuery, PageIsPristineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageIsPristineQuery, PageIsPristineQueryVariables>(PageIsPristineDocument, options);
        }
export function usePageIsPristineSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PageIsPristineQuery, PageIsPristineQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageIsPristineQuery, PageIsPristineQueryVariables>(PageIsPristineDocument, options);
        }
export type PageIsPristineQueryHookResult = ReturnType<typeof usePageIsPristineQuery>;
export type PageIsPristineLazyQueryHookResult = ReturnType<typeof usePageIsPristineLazyQuery>;
export type PageIsPristineSuspenseQueryHookResult = ReturnType<typeof usePageIsPristineSuspenseQuery>;
export type PageIsPristineQueryResult = Apollo.QueryResult<PageIsPristineQuery, PageIsPristineQueryVariables>;